<!--
   Created by qing on 2020/2/8 6:49 下午
   Des: 选人选部门框架
-->
<template>
  <div class="contact-container" v-if="!loading">
    <van-search
      shape="round"
      readonly
      :placeholder="placeholder"
      @focus="searchFocus">
    </van-search>
    <van-tabs v-model="active" v-if="showTab" class="contact-tabs">
      <van-tab
        title="人员"
        name="member"
        v-if="currentIsMember && hasMember">
      </van-tab>
      <van-tab
        title="部门"
        name="dep"
        v-if="currentIsMember && hasDep">
      </van-tab>
      <van-tab
        title="角色"
        name="role"
        v-if="currentIsMember && hasRole">
      </van-tab>
      <van-tab
        title="外部联系人"
        name="external"
        v-if="hasExt">
      </van-tab>
      <van-tab
        title="外部联系人标签"
        name="externalTag"
        v-if="currentIsMember && hasLabel">
      </van-tab>
      <van-tab
        title="当前用户"
        name="current"
        v-if="hasCurrent">
      </van-tab>
    </van-tabs>
    <div class="list-container">
      <ListContainer
        v-if="active === 'member'"
        :key="'member'"
        :dep-info="depInfo"
        :disable-member="disableMember"
        :availableMembers="availableMembers"
        :selected="selected"
        :multiple="multiple"
        @showNextDep="pushNextDep"
        @didSelectMemberCell="didSelectMemberCell">
      </ListContainer>
      <ListContainer
        v-if="active === 'dep'"
        :key="'dep'"
        :dep-info="depInfo"
        :disableDep="disableDep"
        :availableDeps="availableDeps"
        :selected="selected"
        :showMemberList="false"
        :showDepCheckbox="true"
        :multiple="multiple"
        @showNextDep="pushNextDep"
        @didSelectDepCell="didSelectDepCell">
      </ListContainer>
      <ListContainer
        v-if="active === 'role'"
        :key="'role'"
        :disable-role="disableRole"
        :available-roles="availableRoles"
        :selected="selected"
        :showMemberList="false"
        :showDepList="false"
        :showRoleList="true"
        :multiple="multiple"
        :roleList="roleList"
        @didSelectRoleCell="didSelectRoleCell">
      </ListContainer>
      <ListContainer
        v-if="active === 'external'"
        :key="'external'"
        :disable-ext="disableExt"
        :availableExt="availableExt"
        :selected="selected"
        :showMemberList="false"
        :showDepList="false"
        :showExtList="true"
        :multiple="multiple"
        :extList="extList"
        @didSelectExtCell="didSelectExtCell">
      </ListContainer>
      <van-tree-select
        v-if="active === 'externalTag'"
        :items="labelList"
        @click-item="didSelectLabelCell"
        :active-id.sync="labelSelect"
        :main-active-index.sync="activeLabelGroup">
      </van-tree-select>
      <div v-if="active === 'current'">
        <van-checkbox-group
          v-model="checkboxCurrent">
          <van-cell>
            <van-checkbox
              v-if="multiple"
              :name="$store.getters.userId"
              :disabled="isMember ? available(availableMembers, disableMember, $store.getters.userId) :
              available(availableExt, disableExt, $store.getters.userId)"
              icon-size="16px">
              <div class="list-item member-item">
                <van-image
                  round
                  width="30"
                  height="30"
                  fit="cover"
                  :src="userInfo.headImg">
                </van-image>
                <span>{{userInfo.nickname || userInfo.userName}}</span>
              </div>
            </van-checkbox>

            <div v-else class="list-item member-item" @click="didSelectCurrentCell()">
              <van-image
                round
                width="30"
                height="30"
                fit="cover"
                :src="userInfo.headImg">
              </van-image>
              <span>{{userInfo.nickname || userInfo.userName}}</span>
            </div>
          </van-cell>
        </van-checkbox-group>
      </div>
    </div>
    <div class="footer" :style="{justifyContent: multiple ? 'space-between' : 'flex-end'}">
      <div
        class="select-info"
        v-if="multiple"
        @click="showSelectList">
        {{selectNum}}
        <van-icon
          v-if="!confirmBtnDisabled"
          name="arrow-up">
        </van-icon>
      </div>
      <div class="handle-info">
        <div
          class="select-cancel-button"
          @click="cancel">
          取消
        </div>
        <van-button
          v-if="multiple"
          type="info"
          size="small"
          :disabled="confirmBtnDisabled"
          @click="selectComplete">
          确定
        </van-button>
      </div>
    </div>

    <!--子部门弹框-->
    <van-popup
      class="dep-popup"
      v-model="showNext"
      :overlay="false"
      position="right">
      <van-search
        shape="round"
        :placeholder="placeholder"
        @focus="searchFocus">
      </van-search>
      <div
        class="dep-title-container"
        v-if="nextDep">
        <div
          style="margin-left: 5px"
          @click.stop="popSubDepPage">
          <van-icon name="arrow-left"></van-icon>
          返回
        </div>
        <div
          v-for="dep in depStackList"
          :key="dep.depId"
          :class="{'active' : dep.depId === nextDep.depId}"
          @click="popToDep(dep)">
          {{dep.depName}}
          <van-icon name="arrow">
          </van-icon>
        </div>
      </div>
      <ListContainer
        v-if="nextDep"
        :key="nextDep.depId"
        :dep-info="nextDep"
        :selected="selected"
        :showMemberList="active !== 'dep'"
        :showDepCheckbox="active === 'dep'"
        :disable-member="disableMember"
        :disableDep="disableDep"
        :disable-role="disableRole"
        :available-members="availableMembers"
        :available-deps="availableDeps"
        :available-roles="availableRoles"
        :multiple="multiple"
        @showNextDep="showNextDep"
        @didSelectMemberCell="didSelectMemberCell"
        @didSelectDepCell="didSelectDepCell"
        @didSelectRoleCell="didSelectRoleCell">
      </ListContainer>
    </van-popup>

    <!--已选择人员弹框-->
    <van-popup
      class="select-popup"
      v-model="showSelectPopup"
      :overlay="false"
      position="bottom">
      <div class="header">
        <div class="title">请选择</div>
        <div
          class="custom-button"
          @click="showSelectPopup = false">
          确认
        </div>
      </div>
      <van-list>
        <!--部门-->
        <div
          class="divider"
          v-if="selected.dep.length">
          部门
        </div>
        <van-cell v-for="(depId, idx) in selected.dep">
          <div class="member-item">
            <span>{{depMap[depId].depName}}</span>
          </div>
          <van-icon name="close" @click="selected.dep.splice(idx, 1)"></van-icon>
        </van-cell>
        <!--角色-->
        <div
          class="divider"
          v-if="selected.role.length">
          角色
        </div>
        <van-cell v-for="(roleId, idx) in selected.role">
          <div class="member-item">
            <van-image
              v-if="fetchRoleFormId(roleId).roleIcon"
              round
              width="30"
              height="30"
              fit="cover"
              :src="fetchRoleFormId(roleId).roleIcon">
            </van-image>
            <avatar
              v-else
              style="margin-right: 5px"
              backgroundColor="#FFC107"
              :username="fetchRoleFormId(roleId).roleName"
              :size="30">
            </avatar>
            <span>{{fetchRoleFormId(roleId).roleName}}</span>
          </div>
          <van-icon name="close" @click="selected.role.splice(idx, 1)"></van-icon>
        </van-cell>
        <!--成员-->
        <div
          class="divider"
          v-if="selected.member.length">
          成员
        </div>
        <van-cell v-for="(userId, idx) in selected.member">
          <div class="member-item">
            <van-image
              round
              width="30"
              height="30"
              fit="cover"
              :src="fetchMemberFormId(userId).headImg">
            </van-image>
            <span>{{fetchMemberFormId(userId).nickname}}</span>
          </div>
          <van-icon name="close" @click="selected.member.splice(idx, 1)"></van-icon>
        </van-cell>

        <!--外部联系人-->
        <div
          class="divider"
          v-if="selected.ext.length">
          外部联系人
        </div>
        <van-cell v-for="(userId, idx) in selected.ext">
          <div class="member-item">
            <van-image
              v-if="fetchExtFormId(userId).headImg"
              round
              width="30"
              height="30"
              fit="cover"
              :src="fetchExtFormId(userId).headImg">
            </van-image>
            <avatar
              v-else
              style="margin-right: 5px"
              backgroundColor="#FFC107"
              :username="fetchExtFormId(userId).orgUserName"
              :size="30">
            </avatar>
            <span>{{fetchExtFormId(userId).orgUserName}}</span>
          </div>
          <van-icon name="close" @click="selected.ext.splice(idx, 1)"></van-icon>
        </van-cell>

        <!--外部联系人标签-->
        <div
          class="divider"
          v-if="selected.label.length">
          外部联系人
        </div>
        <van-cell v-for="(labelId, idx) in selected.label">
          <div class="member-item">
            <span>{{fetchLabelFormId(labelId).labelName}}</span>
          </div>
          <van-icon name="close" @click="selected.label.splice(idx, 1)"></van-icon>
        </van-cell>

      </van-list>
    </van-popup>

    <!--搜索弹框-->
    <van-popup
      class="search-popup"
      v-model="showSearch"
      :overlay="false"
      position="right">
      <Search
        :user-id="userId"
        :company-id="companyId"
        :queryType="active"
        :disable-member="disableMember"
        :disableDep="disableDep"
        :disable-role="disableRole"
        :disable-ext="disableExt"
        :disable-label="disableLabel"
        :available-members="availableMembers"
        :available-deps="availableDeps"
        :available-roles="availableRoles"
        :available-ext="availableExt"
        :multiple="multiple"
        :selected="selected"
        @onCancel="showSearch = false"
        @didSelectMemberCell="didSelectMemberCell"
        @didSelectDepCell="didSelectDepCell"
        @didSelectRoleCell="didSelectRoleCell"
        @didSelectExtCell="didSelectExtCell"
        @didSelectLabelCell="didSelectLabelCell">
      </Search>
    </van-popup>
  </div>
</template>

<script>
  import ListContainer from "./ListContainer"
  import Search from "./Search"
  import {clone} from "../../../assets/js/Untis"
  import {COMPANY_NOT_EXIST_ERROR, SUCCESS} from "../../store/types"
  import Avatar from 'vue-avatar'

  export default {
    props: {
      userId: {
        type: Number,
        default: null
      },
      companyId: {
        type: String,
        default: ''
      },
      // 是否有人员选择
      hasMember: {
        type: Boolean,
        default: true
      },
      // 是否有部门选择
      hasDep: {
        type: Boolean,
        default: true
      },
      // 是否有角色
      hasRole: {
        type: Boolean,
        default: true
      },
      // 是否有外部联系人
      hasExt: {
        type: Boolean,
        default: true
      },
      // 是否有外部联系人标签
      hasLabel: {
        type: Boolean,
        default: true
      },
      // 是否有当前用户
      hasCurrent: {
        type: Boolean,
        default: true
      },

      // 是否多选
      multiple: {
        type: Boolean,
        default: true
      },
      // 上下文对象
      context: Object | null,
      // 选中的部门
      selectedDep: {
        type: Array,
        default: () => []
      },
      // 选中的角色
      selectedRole: {
        type: Array,
        default: () => []
      },
      // 选中的人员
      selectedMember: {
        type: Array,
        default: () => []
      },
      // 选中的外部联系人
      selectedExt: {
        type: Array,
        default: () => []
      },
      // 选中的外部联系人标签
      selectedLabel: {
        type: Array,
        default: () => []
      },

      // 移除的部门
      removeDep: {
        type: Array,
        default: () => []
      },
      // 移除的角色
      removeRole: {
        type: Array,
        default: () => []
      },
      // 移除的人员
      removeMember: {
        type: Array,
        default: () => []
      },
      // 移除的外部联系人
      removeExt: {
        type: Array,
        default: () => []
      },
      // 移除的外部联系人标签
      removeLabel: {
        type: Array,
        default: () => []
      },

      // 不可选的部门
      disableDep: {
        type: Array,
        default: () => []
      },
      // 不可选的角色
      disableRole: {
        type: Array,
        default: () => []
      },
      // 不可选的人员
      disableMember: {
        type: Array,
        default: () => []
      },
      // 不可选的外部联系人
      disableExt: {
        type: Array,
        default: () => []
      },
      // 不可选的外部联系人标签
      disableLabel: {
        type: Array,
        default: () => []
      },

      // 部门可选择的 idList
      availableDeps: {
        type: Array,
        default: () => []
      },
      // 成员可选择的 idList
      availableMembers: {
        type: Array,
        default: () => []
      },
      // 角色可选择的 idList
      availableRoles: {
        type: Array,
        default: () => []
      },
      // 外部联系人可选择的 idList
      availableExt: {
        type: Array,
        default: () => []
      },
    },
    data() {
      return {
        loading: false,
        active: 'member',
        memberList: [],
        depInfo: null,
        roleList: [],
        depMap: null,
        // 外部联系人
        extList: [],
        // 外部联系人标签
        labelList: [],

        // 选中的对象
        selected: {
          dep: clone(this.selectedDep),
          role: clone(this.selectedRole),
          member: clone(this.selectedMember),
          ext: clone(this.selectedExt),
          label: clone(this.selectedLabel)
        },
        // 是否进入子部门
        showNext: false,
        // 进入的子部门对象
        nextDep: null,
        // 路过的部门对象集合
        depStackList: [],
        // 选择人数
        selectMemberNum: this.selectedMember.length,
        // 选择部门数
        selectDepNum: this.selectedDep.length,
        // 选择角色数
        selectRoleNum: this.selectedRole.length,
        // 选择外部联系人数
        selectExtNum: this.selectedExt.length,
        // 选择外部联系人标签数
        selectLabelNum: this.selectedLabel.length,
        // 显示已选择列表
        showSelectPopup: false,
        // 显示搜索
        showSearch: false,

        selectLabelId: '',
        activeLabelGroup: 0,

        // 自己是否是项目部成员，或者是外部联系人
        isMember: true,
        userInfo: {}
      };
    },
    components: {
      ListContainer,
      Search,
      Avatar
    },
    computed: {
      currentIsMember() {
        return this.memberList.some(user => user.userId === this.$store.getters.userId)
      },
      selectNum() {
        let s = '已选择：'
        if (this.hasMember || (this.hasCurrent && this.isMember)) {
          s += `${this.selectMemberNum}个团队成员`
        }
        if (this.hasDep && this.selectDepNum) {
          if (this.hasMember) {
            s += '、'
          }
          s += `${this.selectDepNum}个部门`
        }
        if (this.hasRole && this.selectRoleNum) {
          if (this.hasMember || this.hasMember) {
            s += '、'
          }
          s += `${this.selectRoleNum}个角色`
        }
        if ((this.hasExt || (this.hasCurrent && !this.isMember)) && this.selectExtNum) {
          if (this.hasMember || this.hasMember || this.hasRole) {
            s += '、'
          }
          s += `${this.selectExtNum}个外部联系人`
        }
        if (this.hasLabel && this.selectLabelNum) {
          if (this.hasMember || this.hasMember || this.hasRole || this.hasExt) {
            s += '、'
          }
          s += `${this.selectLabelNum}个外部联系人标签`
        }
        return s
      },
      confirmBtnDisabled() {
        let disabled = true
        if (this.hasMember && this.selectMemberNum > 0) {
          disabled = false
        }
        if (this.hasDep && this.selectDepNum > 0) {
          disabled = false
        }
        if (this.hasRole && this.selectRoleNum > 0) {
          disabled = false
        }
        if (this.hasExt && this.selectExtNum > 0) {
          disabled = false
        }
        if (this.hasLabel && this.selectLabelNum > 0) {
          disabled = false
        }
        if (this.hasCurrent && (this.selectMemberNum > 0 || this.selectExtNum > 0)) {
          disabled = false
        }
        return disabled
      },
      showTab() {
        let count = 0
        if (this.hasMember) count++
        if (this.hasDep) count++
        if (this.hasRole) count++
        if (this.hasExt) count++
        if (this.hasLabel) count++
        if (this.hasCurrent) count++
        return count > 0
      },
      placeholder() {
        if (this.active === 'role') {
          return '点击搜索角色'
        }
        if (this.active === 'dep') {
          return '点击搜索部门'
        }
        if (this.active === 'member' || this.active === 'current') {
          return '点击搜索人员'
        }
        if (this.active === 'external') {
          return '点击搜索外部联系人'
        }
        if (this.active === 'externalTag') {
          return '点击搜索外部联系人标签'
        }
      },
      labelSelect: {
        set(val) {
          if (this.multiple) {
            this.selected.label.splice(0, this.selected.label.length, ...val)
          } else {
            this.selectLabelId = val
          }
        },
        get() {
          return this.multiple ? this.selected.label : this.selectLabelId
        }
      },
      checkboxCurrent: {
        set(val) {
          if (this.isMember) {
            this.selected.member.splice(0, this.selected.member.length, ...val)
          } else {
            this.selected.ext.splice(0, this.selected.ext.length, ...val)
          }
        },
        get() {
          return this.isMember ? this.selected.member : this.selected.ext
        }
      }
    },
    created() {

      this.loading = true
      const toast = this.$toast.loading('加载中...')

      // 获取人员信息
      this.$store.dispatch('getCompanyOrganization')
        .then(res => {
          this.memberList = res.memberList
          this.depInfo = res.depInfo
          this.roleList = res.roleList
          const leaveExternalList = res.leaveExternalList.filter(ext => {
            this.$set(ext, 'leave', 1)
            return ext
          })
          this.extList = [...res.externalList, ...leaveExternalList]
          res.labelGroupList.forEach((item, idx) => {
            let children = []
            item.labelNameList.forEach(label => {
              children.push({
                ...label,
                text: label.labelName,
                id: label.labelId,
                disabled: this.disableLabel.includes(label.labelId)
              })
            })
            this.labelList.push({
              ...item,
              text: item.labelGroupName,
              id: item.labelGroupId,
              children
            })
          })
        })
      // Promise.all([
      //   // 获取人员信息
      //   this.$store.dispatch('actionCompanyUndistributedUserListV2', {
      //     currentPage: 1,
      //     pageSize: 200
      //   }),
      //   // // 获取部门信息
      //   // this.$store.dispatch('companyDepInfo', companyId),
      //   // 获取角色信息
      //   this.$store.dispatch('fetchRoleList',{}),
      //   // // 获取外部联系人
      //   this.$store.dispatch('actionNewExternalList',{
      //     currentPage: 1,
      //     pageSize: 200
      //   }),
      //   // 获取外部联系人标签
      //   this.$store.dispatch('actionLabelGroupList',{}),
      //
      //   this.$store.dispatch('actionLeaveMemberList'),
      //   this.$store.dispatch('actionLeaveExternalList'),
      //   this.$store.dispatch('actionCompanyDepInfo')
      // ]).then(([userList, roleList, extList, labelList, leaveMemberList, leaveExtList, depInfo]) => {
      //     this.memberList = userList
      //     this.depInfo = depInfo
      //     this.roleList = roleList
      //     const leaveExternalList = leaveExtList.filter(ext => {
      //       this.$set(ext, 'leave', 1)
      //       return ext
      //     })
      //     this.extList = [...extList, ...leaveExternalList]
      //     labelList.forEach((item, idx) => {
      //       let children = []
      //       item.labelNameList.forEach(label => {
      //         children.push({
      //           ...label,
      //           text: label.labelName,
      //           id: label.labelId,
      //           disabled: this.disableLabel.includes(label.labelId)
      //         })
      //       })
      //       this.labelList.push({
      //         ...item,
      //         text: item.labelGroupName,
      //         id: item.labelGroupId,
      //         children
      //       })
      //     })
      // })
        .catch(console.error)
        .finally(() => {

          if (this.depInfo) {
            let leaveMemberList = this.$store.getters.leaveMemberList.filter(user => {
              this.$set(user, 'leave', 1)
              return user
            })
            this.depInfo.memberList.push(...this.memberList, ...leaveMemberList)
            this.depStackList.push(this.depInfo)
            this.depMap = this.fetchDepMap()
          }
          // 判断自己是团队成员还是外部联系人
          // const members = this.$store.state.userList.map(user => user.userId)
          if (this.$store.getters.adminInfo.isMember) {
            this.userInfo = this.$store.state.userList.filter(user => user.userId === this.$store.getters.userId)[0]
            this.isMember = true
          } else {
            this.userInfo = this.$store.getters.extList.filter(user => user.userId === this.$store.getters.userId)[0]
            this.userInfo.userName = this.userInfo.orgUserName
            this.isMember = false
          }
          if (this.hasCurrent) {
            this.active = 'current'
          }
          if (this.hasLabel) {
            this.active = 'externalTag'
          }
          if (this.hasExt) {
            this.active = 'external'
          }
          if (this.hasRole && this.currentIsMember) {
            this.active = 'role'
          }
          if (this.hasDep && this.currentIsMember) {
            this.active = 'dep'
          }
          if (this.hasMember && this.currentIsMember) {
            this.active = 'member'
          }
          this.loading = false
          toast.clear()
        })
    },
    methods: {
      available(availableList, disableList, id) {
        if (availableList.length) {
          return !availableList.includes(id)
        } else {
          return disableList.includes(id)
        }
      },
      // 进入下一个部门
      pushNextDep(item) {
        this.depStackList.push(item)
        this.nextDep = item
        this.showNext = true
      },
      // 进入下一个部门
      showNextDep(item) {
        this.depStackList.push(item)
        this.nextDep = item
      },
      // 推出子部门弹框
      popSubDepPage() {
        this.depStackList.splice(0, this.depStackList.length, this.depInfo)
        this.showNext = false
      },
      // 返回指定部门
      popToDep(dep) {
        let arrTmp = []
        for (let i = 0; i < this.depStackList.length; i++) {
          let depTmp = this.depStackList[i]
          arrTmp.push(depTmp)
          if (dep.depId === depTmp.depId) {
            break
          }
        }
        this.depStackList.splice(0, this.depStackList.length, ...arrTmp)
        if (arrTmp.length === 1) {
          this.showNext = false
        } else {
          this.nextDep = dep
        }
      },
      // 展示已选择人员的list
      showSelectList() {
        if (this.selected.member.length > 0 ||
          this.selected.dep.length > 0 ||
          this.selected.role.length > 0 ||
          this.selected.ext.length > 0 ||
          this.selected.label.length > 0) {
          this.showSelectPopup = true
        }
      },
      // 通过userId获取user对象
      fetchMemberFormId(userId) {
        let member = this.depInfo.memberList.filter(member => member.userId === userId)[0]
        return member || {}
      },
      // 通过roleId获取role对象
      fetchRoleFormId(roleId) {
        let role = this.roleList.filter(role => role.roleId === roleId)[0]
        return role || {}
      },
      // 通过userId获取ext对象
      fetchExtFormId(userId) {
        let ext = this.extList.filter(ext => ext.userId === userId)[0]
        return ext || {}
      },
      // 通过labelId获取label对象
      fetchLabelFormId(labelId) {
        let label = null
        for (let i = 0; i < this.labelList.length; i++) {
          const labelGroup = this.labelList[i]
          label = labelGroup.labelNameList.filter(label => label.labelId === labelId)[0]
          if (label) break
        }
        return label || {}
      },
      // 获取部门map
      fetchDepMap() {
        let map = {}
        if (this.depInfo.hasSub && this.depInfo.subDepList.length) {
          eachDep(this.depInfo.subDepList)
        }
        return map

        function eachDep(list) {
          list.forEach(dep => {
            map[dep.depId] = dep
            if (dep.hasSub && dep.subDepList.length) eachDep(dep.subDepList)
          })
        }
      },
      // 点击搜索
      searchFocus(event) {
        event.stopPropagation()
        this.showSearch = true
      },
      // 完成选择
      selectComplete() {
        let memberInfos = this.depInfo.memberList.filter(member => this.selected.member.includes(member.userId))
        let roleInfos = this.roleList.filter(role => this.selected.role.includes(role.roleId))
        let depInfos = []
        this.selected.dep.forEach(depId => {
          depInfos.push(this.depMap[depId])
        })
        let extInfos = this.extList.filter(ext => this.selected.ext.includes(ext.userId))
        let labelInfos = []
        for (let i = 0; i < this.labelList.length; i++) {
          const labelGroup = this.labelList[i]
          labelInfos.push(...labelGroup.labelNameList.filter(label => this.selected.label.includes(label.labelId)))
        }

        let map = {}
        memberInfos.forEach(user => {
          map[user.userId] = user
        })
        this.$store.commit('UPDATE_USER_MAP', map)
        let extMap = {}
        extInfos.forEach(item => {
          extMap[item.userId] = item
        })
        this.$store.commit('UPDATE_EXTERNAL_MAP', extMap)

        this.$emit('selectedComplete', {
          context: this.context, // 上下文对象
          memberIds: this.selected.member, // 人员ID数组
          depIds: this.selected.dep, // 部门ID数组
          roleIds: this.selected.role, //角色ID数组
          extIds: this.selected.ext,
          labelIds: this.selected.label,
          memberInfos: memberInfos, //人员对象数组
          depInfos: depInfos, // 部门对象数组
          roleInfos: roleInfos, // 角色对象数组
          extInfos: extInfos,
          labelInfos: labelInfos,
        })

        this.clearData()
      },

      // 点击选中部门（单选）
      didSelectDepCell(dep) {
        this.$emit('selectedComplete', {
          context: this.context,
          memberIds: [],
          depIds: [dep.depId],
          roleIds: [],
          extIds: [],
          labelIds: [],
          memberInfos: [],
          depInfos: [dep],
          roleInfos: [],
          extInfos: [],
          labelInfos: [],
        })
        this.clearData()
      },
      // 点击选中人员（单选）
      didSelectMemberCell(member) {
        let map = {}
        map[member.userId] = member
        this.$store.commit('UPDATE_USER_MAP', map)
        this.$emit('selectedComplete', {
          context: this.context,
          memberIds: [member.userId],
          depIds: [],
          roleIds: [],
          extIds: [],
          labelIds: [],
          memberInfos: [member],
          depInfos: [],
          roleInfos: [],
          extInfos: [],
          labelInfos: [],
        })
        this.clearData()
      },
      // 点击选中角色（单选）
      didSelectRoleCell(role) {
        this.$emit('selectedComplete', {
          context: this.context,
          memberIds: [],
          depIds: [],
          roleIds: [role.roleId],
          extIds: [],
          labelIds: [],
          memberInfos: [],
          depInfos: [],
          roleInfos: [role],
          extInfos: [],
          labelInfos: [],
        })
        this.clearData()
      },
      // 点击选中外部联系人（单选）
      didSelectExtCell(ext) {
        let extMap = {}
        extMap[ext.userId] = ext
        this.$store.commit('UPDATE_EXTERNAL_MAP', extMap)

        this.$emit('selectedComplete', {
          context: this.context,
          memberIds: [],
          depIds: [],
          roleIds: [],
          extIds: [ext.userId],
          labelIds: [],
          memberInfos: [],
          depInfos: [],
          roleInfos: [],
          extInfos: [ext],
          labelInfos: [],
        })
        this.clearData()
      },
      // 点击选中外部联系人标签（单选）
      didSelectLabelCell(data) {
        this.$emit('selectedComplete', {
          context: this.context,
          memberIds: [],
          depIds: [],
          roleIds: [],
          extIds: [],
          labelIds: [data.labelId],
          memberInfos: [],
          depInfos: [],
          roleInfos: [],
          extInfos: [],
          labelInfos: [data],
        })
        this.clearData()
      },
      // 点击自己（单选）
      didSelectCurrentCell() {

        this.$emit('selectedComplete', {
          context: this.context,
          memberIds: this.isMember ? [this.userInfo.userId] : [],
          depIds: [],
          roleIds: [],
          extIds: this.isMember ? [] : [this.userInfo.userId],
          labelIds: [],
          memberInfos: this.isMember ? [this.userInfo] : [],
          depInfos: [],
          roleInfos: [],
          extInfos: this.isMember ? [] : [this.userInfo],
          labelInfos: [],
        })
        this.clearData()
      },

      cancel() {
        console.log(this.selected)
        this.$emit('onCancel')
        this.clearData()
      },
      clearData() {
        this.showNext = false
        this.nextDep = null
        this.depStackList = []
        this.showSearch = false
      }
    },
    watch: {
      'selected.member'() {
        this.selectMemberNum = this.selected.member.length
      },
      'selected.dep'() {
        this.selectDepNum = this.selected.dep.length
      },
      'selected.role'() {
        this.selectRoleNum = this.selected.role.length
      },
      'selected.ext'() {
        this.selectExtNum = this.selected.ext.length
      },
      'selected.label'() {
        this.selectLabelNum = this.selected.label.length
      }
    }
  };
</script>

<style lang="less">

  .contact-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: calc(env(safe-area-inset-bottom));
    overflow: hidden;
    display: flex;
    flex-direction: column;

    .van-tabs {
      height: 44px;
      /*height: calc(100% - 54px - 44px);*/

      /*.van-tabs__content {*/
      /*  height: calc(100% - 44px);*/
      /*  overflow: auto;*/
      /*}*/

      .van-tabs__line {
        background-color: #63B2EE;
      }
    }

    .van-tree-select {
      .van-sidebar-item--select {
        border-color: #63B2EE;
      }

      .van-tree-select__content {

        .van-tree-select__item--active {
          color: #63B2EE;
        }
      }
    }

    .list-container {
      flex: 1;
      overflow: auto;
      -webkit-overflow-scrolling: touch;
      background-color: #F5F5F5;

      .list-item {
        display: flex;
        align-items: center;

        .van-image {
          margin-right: 10px;
        }
      }
    }

    .footer {
      height: 44px;
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 10px;
      background-color: #fff;
      border-top: 1px solid #d5d6d9;

      .select-info {
        font-size: 12px;
        color: #63B2EE;
        display: flex;
        align-items: center;
        flex: 1;
        margin-right: 10px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .van-icon {
          margin-left: 5px;
        }
      }

      .handle-info {
        font-size: 14px;
        width: 100px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .select-cancel-button {
          color: #959699;
          margin-right: 10px;
        }
      }

    }

    .van-popup--right {
      top: calc(50% - 22px - env(safe-area-inset-bottom) / 2);
    }

    .dep-popup {
      width: 100%;
      height: calc(100% - 44px);
      background-color: #F5F5F5;

      .dep-title-container {
        height: 40px;
        width: calc(100% - 10px);
        overflow-x: auto;
        overflow-y: hidden;
        display: flex;
        align-items: center;
        padding-left: 10px;
        white-space: nowrap;
        background-color: #fff;

        div {
          margin-left: 5px;
          height: 20px;
          display: flex;
          font-size: 14px;
          color: #7f828b;
        }

        .active {
          color: #63B2EE;
        }
      }
    }

    .select-popup {
      width: 100%;
      height: 100%;
      overflow: hidden;

      .header {
        height: 44px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 20px;
        border-bottom: 1px solid #ebedf0;

        .title {
          flex: 1;
          text-align: center;
          padding-left: 20px;
          font-size: 16px;
        }

        .custom-button {
          color: #63B2EE;
          font-size: 14px;
          width: 28px;
        }
      }

      .van-list {
        height: calc(100% - 44px);
        overflow: auto;
        background-color: #F5F5F5;

        .van-cell__value {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;

          .member-item {
            display: flex;
            align-items: center;
            width: 100%;

            .van-image {
              margin-right: 10px;
            }
          }
        }

        .divider {
          width: 100%;
          height: 30px;
          background-color: #F5F5F5;
          display: flex;
          align-items: center;
          padding-left: 24px;
          font-size: 12px;
        }
      }
    }

    .search-popup {
      width: 100%;
      height: calc(100% - 44px - env(safe-area-inset-bottom));
      background-color: #F5F5F5;
    }
  }
</style>
